import NavbarWhite from "../../components/NavbarWhite";
import MediaButtons from "../../components/MediaButtons";
import Footer from "../../components/Footer";
import ButtonTop from "../../components/ButtonTop";
import CookiesAccept from "../../components/CookiesAccept";

import ContactOne from "./components/ContactOne";

function Contact() {
  return (
    <div id="contact">
      <NavbarWhite></NavbarWhite>
      <ButtonTop></ButtonTop>
      <MediaButtons></MediaButtons>
      <CookiesAccept></CookiesAccept>
      <ContactOne></ContactOne>
      <Footer></Footer>
    </div>
  );
}

export default Contact;
